<template>
  <!-- 发票管理 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="申请流水:" prop="batchNo">
                <el-input  placeholder="" v-model="searchFrom.batchNo"></el-input>
              </el-form-item>
              <el-form-item label="申请状态:" prop="batchStatus">
                <el-select  v-model="searchFrom.batchStatus"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待审核" value="1"></el-option>
                  <el-option label="待支付 " value="3"></el-option>
                  <el-option label="审核通过" value="4"></el-option>
                  <el-option label="审核驳回" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
          <el-form-item btnCode="00JP00BB001" >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" v-if="btnFlg[1] && scope.row.batchStatus==3" @click="fukuanFn(scope.row)">支付</el-button>
              <el-button type="text" size="mini" btnCode="00JP00BB004"  v-if="btnFlg[0] && scope.row.batchStatus==2" @click="delFN(scope.row)">删除</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="batchNo" width="200"  :formatter="emptyFn"   label="申请流水"></el-table-column>
        <el-table-column property="submitNum" label="发票数量">
          <template scope="scope">
               <el-button type="text" size="mini" btnCode="006P009B003"    @click="danjuFN(scope.row)">{{scope.row.submitNum}}</el-button>
          </template>
        </el-table-column>
         <el-table-column property="batchStatus" label="申请状态">
          <template scope="scope">{{[ "待审核","审核驳回","待支付","审核通过" ][scope.row.batchStatus-1]}}</template>
        </el-table-column>
         <el-table-column property="invoiceAmount"  width="170"  label="发票金额合计(元)">
          <template scope="scope">
               <span style="color:#F56C6C">{{scope.row.invoiceAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="申请时间"></el-table-column>
        <el-table-column width="170" property="examineTime" :formatter="dateTimeFormat" label="审核时间"></el-table-column>
        <el-table-column width="200" property="examineReason" :formatter="emptyFn" label="审核原因 "></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,300,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 申请开票 -->
    <el-dialog  title="申请开票"  :visible.sync="dialogSQ" width="400px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQfrom" ref="SQfrom" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
              <el-form-item prop="password" label="邮费:">
                  <span style="color:red;font-size:18px">{{SQfrom.youfei}}</span>元
              </el-form-item>
             <el-form-item prop="password" label="支付密码:">
                  <el-input
                    v-model="SQfrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
        </div>
        <div style="background: rgba(225,50,70,0.1);padding: 4px 20px; margin-top:20px">
            <p>提示</p>
            <p>每月首次申请开票免发票邮寄费用！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SQsave()">确认申请</el-button>
        <el-button @click="dialogSQ = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 付款 -->
    <el-dialog  title="付款"  :visible.sync="fukuanMark" width="600px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="fukuanFrom" ref="fukuanFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
             <div style="display: flex;justify-content: space-between; ">
                <p>应付合计:<span style="color:red;font-size:18px">{{fukuanFrom.ext1}}</span>元</p>
                <p>储蓄金额:<span >{{fukuanFrom.accountMoney}}</span>元</p>
             </div>
             <div style="text-align: center; margin: 28px 0;">
               <el-form-item prop="password" label="支付密码:">
                  <el-input
                    v-model="fukuanFrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fukuanMark = false">取消</el-button>
        <el-button type="primary" @click="ZFsave()">支付</el-button>
      </span>
   </el-dialog>
   <!-- 单据明细 -->
    <el-dialog  title="发票明细"  :visible.sync="dialogDJMX" width="1100px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <el-table :data="DJMXlist"  ref="DJMXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="400" style="width: 100%" center border
        row-key="id" lazy :load="load" :row-class-name="tableRowClassName" :tree-props="{children: 'children'}">
        <el-table-column   prop="date" width="50" label=""></el-table-column>
        <el-table-column type="index"  prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="invoiceType" label="业务类型" width="120">
          <template scope="scope">{{[ "运输业务", "快递业务", "找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="platformZxAccNm"  width="220"  :formatter="emptyFn"   label="开票企业"></el-table-column>
        <el-table-column property="wayAxrate"  width="120"  :formatter="emptyFn"   label="发票税率"></el-table-column>
        <el-table-column property="wayMoney"  width="150"  label="发票金额(元)">
          <template scope="scope">
               <span style="color:#F56C6C">{{scope.row.wayMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column property="issuingOffice" width="100"     label="开票单位">
          <template scope="scope">
            <div>
             <span v-if="scope.row.invoiceType==1">{{scope.row.issuingOffice}}</span>
              <span v-if="scope.row.invoiceType!=1" >-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column  property="createTime" :formatter="dateTimeFormat" label="打包时间"></el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDJMX = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn, dateTimeFormat } from '@/utils/util'
import { tOwnerInvoiceBatchList, vailPostageMoney, invoiceUpdates, invoiceList, tOwnerInvoiceBatchUpdates, authenticationPwd, // 验证支付密码
  upToPayDetail, detailByBusinessNo, shipperPayment } from '@/api/consignment'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 付款
      fukuanMark: false,
      fukuanFrom: {
        ext1: 0,
        accountMoney: 0,
        ids: ''
      },
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      // 申请开票
      dialogSQ: false,
      SQfrom: {
        youfei: 0
      },
      // 发票明细
      dialogDJMX: false,
      DJMXlist: [],
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        password: { required: true, message: '请输入密码', trigger: 'blur' }
      },
      ids: [],
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00JP00MB001', '00JP00MB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payCustomer/faPiaoShenQing')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (!row.hasChildren) {
        return 'nocheck'
      }
    },
    load (tree, treeNode, resolve) {
      console.log(tree)

      let data = { ...tree }
      data.id = 'c' + data.id
      data.wayAxrate = data.serviceAxrate
      data.wayMoney = data.serviceMoney
      data.wayInvoiceNo = data.serviceInvoiceNo
      data.hasChildren = false
      resolve([
        data
      ])
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/owner/invoice/exportSocInvoiceList ',
        form,
        '发票管理列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 打包开票
    DBKPfn () {
      this.$router.push({ path: '/payCustomer/invoiceApply' })
    },
    // 单据数量
    danjuFN (row) {
      this.row = row
      invoiceList({ batchId: row.id }).then(res => {
        this.DJMXlist = res
        this.dialogDJMX = true
      })
    },
    // 删除
    delFN (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        tOwnerInvoiceBatchUpdates({ ids: [row.id], flag: 0 }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 撤回
    chehuiFN (row) {
      this.$confirm('是否执行撤回审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceUpdates({ ids: [row.id], flag: 1 }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 支付
    fukuanFn (row) {
      detailByBusinessNo({ batchNo: row.batchNo }).then(res => {
        this.fukuanFrom.ids = res.id.toString()
        this.fukuanFrom.settlementAccountId = res.settlementAccountId
        upToPayDetail({ ids: res.id + '' }).then(res => {
          this.fukuanFrom.ext1 = res.ext1
          this.fukuanMark = true
          this.fukuanFrom.accountMoney = res.accountMoney
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            duration: 0,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          duration: 0,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    ZFsave () {
      if (this.fukuanFrom.ext1 > this.fukuanFrom.accountMoney) {
        this.$confirm('账户余额不足请充值?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ path: '/payCustomer/recharge' })
        }).catch(() => {

        })
      } else {
        let data = encryption({
          data: { id: this.fukuanFrom.settlementAccountId, password: this.fukuanFrom.password },
          key: this.global.key,
          param: ['password']
        })
        this.$refs.fukuanFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            authenticationPwd(data).then(res => {
              shipperPayment({ ids: this.fukuanFrom.ids }).then(res => {
                loading.close()
                this.fukuanMark = false
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  duration: 0,
                  type: 'success',
                  onClose () {
                    loading.close()
                  }
                })
                this.getList(this.searchFrom)
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  duration: 0,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 申请开票
    SQKPfn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false
        this.ids = []
        selectData.some(item => {
          if (item.invoiceStatus != 1) { //
            this.$alert('该状态下的数据不能申请开票', '系统提示')
            isHQ = false
            return true
          } else {
            this.ids.push(item.id)
            isHQ = true
          }
        })
        if (isHQ) {
          vailPostageMoney().then(res => {
            if (res == 0) {
              this.SQJiekou('')
            } else {
              this.SQfrom.youfei = res
              this.dialogSQ = true
            }
          })
        }
      }
    },
    SQsave () {
      let data = encryption({
        data: this.SQfrom,
        key: this.global.key,
        param: ['password']
      })
      this.SQJiekou(data.password)
    },
    SQJiekou (payPwd) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      invoiceUpdates({
        flag: 2,
        ids: this.ids,
        payPwd: payPwd
      }).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.getList(this.searchFrom)
        this.dialogSQ = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },

    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tOwnerInvoiceBatchList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        applyTime: null
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
      this.fukuanFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.nocheck .el-checkbox{
  display: none;
}
</style>
